import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';
import Display_Actions from '../../../Display_Actions/Display_Actions';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Editbox from '../../../Part_Sample/Editbox';

export default class Add_Edit_Pattern extends Component {
	constructor(props) {
		super(props);

		this.lastClickTime = false;

		this.pattern = {};
		let pattern_name = '';

		if (this.props.param.pattern != null) {
			this.pattern = JSON.parse(JSON.stringify(this.props.param.pattern));
			pattern_name = this.pattern.name;
		} else if (this.props.param.pattern_id != '') {
			this.pattern = this.props.param.schedule.pattern[this.props.param.pattern_id]
			pattern_name = this.pattern.name;
		} else {
			this.pattern.action = {};
		}

		this.state = {
			pattern_name: pattern_name,
		}
	}

	preventMultipleTaps = () => {
		if(this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handlePrevious = () => {
		let param = this.props.param;
		// If pattern selected but clicked on add pattern
		if (param.selected_pattern_id != null) {
			param.pattern_id = param.selected_pattern_id;
			delete param.selected_pattern_id;
		}
		if (param.pattern != null) {
			delete param.pattern;
		}
		this.props.content_handler('Schedule_Step3_Pattern', param);
	}

	handleChangePatternName = (val) => {
		this.setState({ pattern_name: val })
	}

	handleAddAction = () => {
		if (!this.preventMultipleTaps()) return;

		this.pattern.name = this.state.pattern_name;
		let param = this.props.param;
		param.pattern = this.pattern
		param.time = null;
		this.props.content_handler('Add_Edit_Action', param);
	}

	handleEditAction = (time) => {
		if (!this.preventMultipleTaps()) return;

		this.pattern.name = this.state.pattern_name;
		let param = this.props.param;
		param.pattern = this.pattern
		param.time = time;
		this.props.content_handler('Add_Edit_Action', param);
	}

	handleRegister = () => {
		if (!this.preventMultipleTaps()) return;

		if (this.state.pattern_name == '' || this.state.pattern_name == null || this.state.pattern_name == undefined) {
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			this.lastClickTime = false;
			return;
		} else if (isEmpty(this.pattern.action)) {
			window.app.showToast(this.props.receiver.getString('no_action'), 3000);
			this.lastClickTime = false;
			return;
		}

		this.pattern.name = this.state.pattern_name;

		if (this.props.param.pattern_id == '') {
			this.props.receiver.addPattern(this.pattern);
		} else {
			let pattern = {};
			pattern[this.props.param.pattern_id] = this.pattern;
			this.props.receiver.modifyPattern(pattern);
		}
	}

	handleDelete = () => {
		if (!this.preventMultipleTaps()) return;

		this.props.receiver.deletePattern(this.props.param.pattern_id);
	}

	rcvAddPattern(response) {
		if (response.result != 'NG') {
			let pattern_id = '';
			let keys = Object.keys(response);
			for (let key of keys) {
				if (key != this.state.pattern_name) pattern_id = key;
			}

			this.props.receiver.next_component = 'Schedule_Step3_Pattern';
			if (this.props.param.from == 'Schedule_Office_Summary' || this.props.param.original_from != null) {
				this.props.receiver.stored_params.original_from = 'Schedule_Office_Summary'
			}
			this.props.receiver.stored_params.program = this.props.param.program;
			this.props.receiver.stored_params.program_id = this.props.param.program_id;
			this.props.receiver.stored_params.op_type = this.props.param.op_type;
			this.props.receiver.stored_params.pattern_id = pattern_id;
			this.props.receiver.getScene();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
			this.lastClickTime = false;
		}
	}

	rcvModifyPattern(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'Schedule_Step3_Pattern';
			if (this.props.param.from == 'Schedule_Office_Summary' || this.props.param.original_from != null) {
				this.props.receiver.stored_params.original_from = 'Schedule_Office_Summary'
			}
			this.props.receiver.stored_params.program = this.props.param.program;
			this.props.receiver.stored_params.program_id = this.props.param.program_id;
			this.props.receiver.stored_params.op_type = this.props.param.op_type;
			this.props.receiver.stored_params.pattern_id = this.props.param.pattern_id;
			this.props.receiver.getScene();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
			this.lastClickTime = false;
		}
	}

	rcvDeletePattern(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'Schedule_Step3_Pattern';
			if (this.props.param.from == 'Schedule_Office_Summary' || this.props.param.original_from != null) {
				this.props.receiver.stored_params.original_from = 'Schedule_Office_Summary'
			}
			this.props.receiver.stored_params.program = this.props.param.program;
			this.props.receiver.stored_params.program_id = this.props.param.program_id;
			this.props.receiver.stored_params.op_type = this.props.param.op_type;
			this.props.receiver.getScene();
		} else {
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
			this.lastClickTime = false;
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.pattern_id == '' ? this.props.receiver.getString('add_routine') : this.props.receiver.getString('edit_routine')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'add'}
						handleRightButton={this.handleAddAction}
					/>
					<div style={{ height: this.props.height - 140, overflow: 'auto' }}>
						<div style={{ width: this.props.width - 40, marginTop: 20, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='pattern_name' style={{}} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangePatternName(event.target.value)} value={this.state.pattern_name} />
						</div>

						<div style={{ marginTop: 20, marginLeft: 20 }}>
							<div>
								<span>{this.props.receiver.getString('actions')}</span>
							</div>
							{Object.keys(this.pattern.action).sort().map((time) => {
								let action_details = this.pattern.action[time];
								return (
									<div style={{ textAlign: 'left', marginTop: 20, width: this.props.width - 40, backgroundColor: '#f1f1f1', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 10, minHeight: 50 }} onClick={() => this.handleEditAction(time)}>
										<div style={{ display: 'inline-block', width: '50%', textAlign: 'left' }}>
											<span style={{ marginLeft: 10 }}> {time} </span>
										</div>
										<Display_Actions style={{ display: 'inline-block', width: '50%', textAlign: 'right' }} point_info={null} actions={action_details} receiver={this.props.receiver} />
									</div>
								)
							})}
						</div>
					</div>

				</div>
			</div>
		)
	}
}